import { useMemo } from 'react';

import { FALSE_KEY, TRUE_KEY } from '@/common/constants';
import { useInvestor } from '@/modules/investments/hooks';
import {
  InvestmentExperience,
  InvestmentObjectives,
  InvestorStatus,
  SelfDirectedInvestmentsQuestionnairePayload,
} from '@/modules/investments/investments.types';
import { useIsModelChangedStore } from '@/modules/investments/stores';

const useDefaultQuestionnaireValues = () => {
  const { data } = useInvestor();
  const isModelChanged = useIsModelChangedStore((state) => state.isModelChanged);
  const defaultValues = useMemo(() => {
    if (isModelChanged) {
      return {};
    }

    const values: Partial<SelfDirectedInvestmentsQuestionnairePayload> = {
      status: data.status as unknown as InvestorStatus,
      position: data.position,
      networthTotal: `${data.networkTotal || ''}`,
      annualIncome: `${data.annualIncome || ''}`,
      employmentType: `${data.employmentType || ''}`,
      broker: data?.broker === undefined ? '' : data?.broker ? TRUE_KEY : FALSE_KEY,

      investmentObjectivesType: data?.investmentObjectivesType as unknown as InvestmentObjectives,
      investmentExperienceType: data?.investmentExperienceType as unknown as InvestmentExperience,
    };
    return values;
  }, [
    data.annualIncome,
    data?.broker,
    data.employmentType,
    data?.investmentExperienceType,
    data?.investmentObjectivesType,
    data.networkTotal,
    data.position,
    data.status,
    isModelChanged,
  ]);

  return defaultValues;
};

export default useDefaultQuestionnaireValues;
